// extracted by mini-css-extract-plugin
export default {"component":"sIk8N"};